import { AdAuthModel } from './ad-auth.model';
import { AppointmentModel } from './appointment.model';
import { AttendeeModel } from './attendee.model';
import { BaseModel } from './base.model';
import { CompanyModel } from './company.model';
import { ImageModel } from './image.model';

export class InstanceModel extends BaseModel {

  static RETENTION_90_DAYS  = 90;
  static RETENTION_180_DAYS = 180;
  static RETENTION_365_DAYS = 365;

  static getRetentionPeriods() {
    return [
      { id: InstanceModel.RETENTION_90_DAYS,  name: '3 months (90 days)'   },
      { id: InstanceModel.RETENTION_180_DAYS, name: '6 months (180 days)'  },
      { id: InstanceModel.RETENTION_365_DAYS, name: '12 months (365 days)' },
    ];
  }

  id: number;
  imageId: number;
  key: string;
  name: string;
  homepageUri: string;
  receptionEmail: string;
  receptionConfig: any;
  lockProvider: string;
  lockProviderConfig: any;
  doorOpener?: string;
  doorOpenerConfig?: any;
  mfaEnabled: 0 | 1;
  dataRetentionDays: 90 | 180 | 365;

  defaultPhotoUrl: string = './assets/images/placeholder-image.png';

  image: ImageModel;
  companies: CompanyModel[];
  appointments: AppointmentModel[];
  attendees: AttendeeModel[];
  adAuths: AdAuthModel[];
  imageFile?: File;

  get childModels(): {} {
    return {
      image: ImageModel,
      companies: CompanyModel,
      appointments: AppointmentModel,
      attendees: AttendeeModel,
      adAuths: AdAuthModel,
    };
  }

  toApi(model?: this): {} {
    return {
      ...super.toApi(model),
      ...((model && model.imageFile) ? { image_file: model.imageFile } : {}),
    };
  }

  get thumbUrl() {
    return this.image?.baseUrl || this.defaultPhotoUrl;
  }
}
